// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2iH7Z","checkboxCol":"Table_checkboxCol__1PeRZ","emailCol":"Table_emailCol__3COxT","actionCol":"Table_actionCol__1jq4l"};